import LoadingBox from 'components/Common/Loading/LoadingBox'
import TextLoadingBox from 'LuxKit/Typography/TextLoadingBox'
import { rem } from 'polished'
import styled from 'styled-components'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import clsx from 'clsx'

const LoaderContainer = styled.div`
  border: 1px solid ${props => props.theme.palette.neutral.surface.lightForeground};
  border-radius: ${props => props.theme.borderRadius.S};
  min-height: ${rem(364)};
  display: grid;
  grid-template-rows: min-content 1fr;
  overflow: hidden;

  &.compact {
    min-height: unset;
  }
`

const ImageBox = styled(LoadingBox)`
  height: ${rem(162)};
  width: 100%;
`

const Content = styled.div`
  padding: ${rem(20)};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: ${rem(8)};
  background-color: ${props => props.theme.palette.neutral.surface.normalBackground};
`

const ButtonLoadingBox = styled(LoadingBox)`
  height: ${rem(40)};
  width: ${rem(80)};
  border-radius: ${props => props.theme.borderRadius.S};
`

const Footer = styled.div`
  margin-top: auto;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
`

const DiscountLoadingBox = styled(LoadingBox)`
  height: ${rem(20)};
  width: ${rem(112)};
  border-radius: ${props => props.theme.borderRadius.S};
`

interface Props {
  className?: string
  showCancellation?: boolean
  showGifting?: boolean
}

function ExperienceTileSkeletonLoader(props: Props) {
  const { className, showCancellation = true, showGifting = true } = props

  return <LoaderContainer className={clsx(className, { compact: !showCancellation && !showGifting })}>
    <ImageBox />
    <Content>
      <VerticalSpacer gap={8}>
        <TextLoadingBox typography="caption-large" width="70%" />
        <TextLoadingBox typography="body-medium" lines={3} width="100%" />
        {showCancellation && <TextLoadingBox typography="body-medium" width="75%" />}
        {showGifting && <TextLoadingBox typography="body-medium" width="70%" />}
        <TextLoadingBox typography="caption-medium" width="60%" />
      </VerticalSpacer>
      <VerticalSpacer gap={4}>
        <DiscountLoadingBox />
        <Footer>
          <div>
            <TextLoadingBox typography="caption-medium" width={28} />
            <TextLoadingBox typography="heading6" width={64} />
          </div>
          <ButtonLoadingBox />
        </Footer>
      </VerticalSpacer>
    </Content>
  </LoaderContainer>
}

export default ExperienceTileSkeletonLoader
